export default __webpack_public_path__ + "static/media/agregar-carrito.afa6f155.png";